import UploadOutlined from '@ant-design/icons/UploadOutlined';
import Alert from 'antd/lib/alert';

import { IPjmMeterDataUpload, MeterDataUploadStatus } from '../../../../../domain/pjm/meter-data-upload/interface';
import { getComputerFormattedTime } from '../../../../../domain/date/date';

export function LatestPjmRegistrationMeterDataUploadStatus({ value }: { value: IPjmMeterDataUpload }) {
    const [season, startYearStr, endYearStr] = value?.seasonId!.split('-');

    const startYear = parseInt(startYearStr);
    const endYear = parseInt(endYearStr);

    const { status, description } = makeStatusAndDescriptionString(value.status, value.error_message);
    return (
        <Alert
            message={
                <>
                    Upload Meter Data file for {season} {startYear - 2} - {endYear - 2} status: <span style={{ fontWeight: 'bold' }}>{status}</span>{' '}
                    {[MeterDataUploadStatus.FAILED, MeterDataUploadStatus.DONE].includes(value.status)
                        ? 'at ' + getComputerFormattedTime(value.date_modified)
                        : ''}
                </>
            }
            description={description}
            type={makeAlertTypeFromStatus(value.status)}
            icon={<UploadOutlined />}
            showIcon
            style={{ margin: '10px 0 20px 0', padding: '8px 12px' }}
        />
    );
}

function makeAlertTypeFromStatus(status: MeterDataUploadStatus) {
    switch (status) {
        case MeterDataUploadStatus.DONE:
            return 'info';
        case MeterDataUploadStatus.READY_TO_GENERATE:
        case MeterDataUploadStatus.PENDING:
            return 'warning';
        case MeterDataUploadStatus.FAILED:
            return 'error';
    }
}

function makeStatusAndDescriptionString(status: MeterDataUploadStatus, errorMessage?: string): { status: string; description: string } {
    switch (status) {
        case MeterDataUploadStatus.DONE:
            return { status: 'Done', description: 'Meter Data file uploaded!' };
        case MeterDataUploadStatus.READY_TO_GENERATE:
            return { status: 'Ready to Generate', description: 'We scheduled process to generate Meter Data file. Please check later.' };
        case MeterDataUploadStatus.PENDING:
            return { status: 'Pending', description: 'Meter Data file was generated. Now we are waiting for upload to DR HUB. Please check later.' };
        case MeterDataUploadStatus.FAILED:
            return { status: 'Failed', description: `Meter Data file upload failed ${errorMessage ? `(${errorMessage})` : ''}` };
    }
}
